import BaseApiAction from '@Actions/base-api-action';
import { Actions } from '@Context/common/general/context';

export default class GetAssignableMembers extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'teams-getAssignableMembers',
      payload: {
        team_id: this._payload.team_id,
      },
    });
  }

  onSuccess(data) {

    for(let i = 0; i < data.length; i++) {
      data[i].filterString = `${data[i].first} ${data[i].last}, ${data[i].email}`.toLowerCase();
    }

    this._dispatch({
      type: Actions.CoreActions.UpdateState,
      payload: {
        admin: {
          users: {
            potentialTeamMembers: data,
          },
        },
      },
    });
    super.onSuccess(data);
  }
}
